import { promiseActionFactory } from "@teroneko/redux-saga-promise";

import { createActionTypes } from "utils/store";
import { IEditInfoScreen, IInfoScreenData } from '../../types/infoScreens.types';

const INFO_SCREEN_ACTIONS = {
  LOAD_INFO_SCREEN: 'LOAD_INFO_SCREEN',
  UPDATE_INFO_SCREEN: 'UPDATE_INFO_SCREEN',
};

const actionTypes = createActionTypes('infoScreens', INFO_SCREEN_ACTIONS);

export const loadInfoScreenAction = promiseActionFactory<IInfoScreenData>().create<{ id: number }>(actionTypes.LOAD_INFO_SCREEN);
export const updateInfoScreenAction = promiseActionFactory<IInfoScreenData>().create<{ id: number, data: IEditInfoScreen }>(actionTypes.UPDATE_INFO_SCREEN);
